<template>
  <div>
    Passport Information
  </div>
</template>

<script>
export default {
  name: "PassportComponent",
  data() {
    return {

    }
  },
  mounted() {},
  methods: {},
};
</script>
